var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBody2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Male_x5F_skins:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "skin_x5F_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EEC183",
    d: "M600.2,606.7c-1-8.2-2.2-16.3-3.4-24.5c6.1-0.4,3.8-3.7,2.7-8.5c-1.2-5.4-2.6-10.7-4.2-16 c-3-10-6.3-19.5-10.4-29c-8.7-20.4-25.7-29.1-45.2-36.9c-29.1-11.6-61.3-15.4-88.7-31.4c-14.4-8.4-22.6-21.2-25.8-37.5 c-2.9-14.5-4.4-28.5-4.6-43.2c-7.8,6-16,11.5-23.5,16.6c-6.6,4.6-13.4,8.3-20.6,11.7c-7.4,3.5-14.5,3.2-22.3,2.3 c-14.9-1.6-30.5-13-42.3-21.6c-6-4.3-11.7-8.6-17.2-13.2c0,15.8-1.5,31.8-4.6,47.3c-3.3,16.3-11.5,29.1-25.8,37.5 c-27.4,16-59.6,19.7-88.7,31.4c-19.5,7.8-35.8,13.2-45.2,36.9c-3.8,9.7-7.4,19.1-10.4,29c-1.6,5.3-9.5,33.9-10.4,46.4 c-0.4,4.9,0,4.3,0.3,4.5c3.9,0.4,9.6-0.7,9.6,0c0,4,0.1,9.7,0.3,14.2c0.1,1.6,0.1,3.5,0.2,4.9c63.7,57.2,147.9,92.1,240.3,92.1 c93.1,0,178-35.4,241.9-93.4C602.4,622.3,600.8,611.4,600.2,606.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EEC183",
    d: "M358.8,103.1c29.9,1.3,65.4,9.4,83,36.4 c9.6,14.7,14.1,28.8,17.7,45.8c3,14.2,1.7,31.5,0,45.8c-1,8.3-4.2,16.1-6.2,24.2c-1.9,7.8-3,15.5-3.9,23.5 c-0.6,6.1,2.5,15.1,3.4,21.3c1.3,8.4,2.8,16.3,2.6,24.8c-0.6,33.8-33.8,54.3-58.5,71.4c-6.6,4.6-13.4,8.3-20.6,11.7 c-7.4,3.5-14.5,3.2-22.3,2.3c-14.9-1.6-30.5-13-42.3-21.6c-13.2-9.6-25.5-19.1-36.8-31.1c-12.1-12.8-14.6-27.1-13.4-44 c1.2-15.3,4.7-30.5,5.2-45.8c0.6-16.6-7.7-29.4-11.4-45c-7.1-29.5-4.9-68.3,21.4-87.9c11.5-8.5,23.5-17.8,37.2-22.7 c7.6-2.7,14.8-5.2,22.6-7.1C344,103.6,351.4,103.5,358.8,103.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC9E65",
    d: "M258.3,232.5c-3.2-2.5-7.1-4-11-2.8c-7.9,2.5-12.3,14.4-12.8,21.4c-1.2,16.4,1.4,27.4,7.6,40.4 c2.4,5.1,11.1,12.9,18.1,11.2c1.1-0.3,2.1-0.9,2.9-1.7c1.5-11,3.5-22.1,3.8-33.1C267.4,254.9,262.3,244.1,258.3,232.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC9E65",
    d: "M473.4,230.2c-5.5-2.5-10.7,0.9-14.5,5c-1.4,6.8-3.9,13.3-5.5,20.2c-1.9,7.8-3,15.5-3.9,23.5 c-0.6,6.1,2.5,15.1,3.4,21.3c0.3,1.7,0.5,3.3,0.8,5c6.6,2,13.7-5.3,16.6-9.9c7.7-12.2,10.7-25.9,11.4-42.4 C482,245.9,480.9,233.6,473.4,230.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#997449",
    d: "M460.8,292c-0.5,0-1-0.4-1-0.9c-2.1-15-1.7-29.5,4.3-43.2c0.2-0.5,1.6-2.7,2.1-2.5s-0.1,1.9-0.3,2.4 c-5.8,13.3-5.2,27.1-4.3,42c0,0.6,0,2-0.5,2.1C461,292,460.9,292,460.8,292L460.8,292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#997449",
    d: "M253.6,290.5c0.5,0,1-0.3,1.1-0.8c3.1-14.3,3.6-28.3-1.4-41.9c-0.2-0.5-1.4-2.8-1.9-2.6 c-0.6,0.2-0.1,1.8,0.1,2.4c4.9,13.2,3.4,26.4,1.5,40.7c-0.1,0.6-0.2,1.9,0.4,2.1C253.4,290.4,253.5,290.5,253.6,290.5 L253.6,290.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC9E65",
    d: "M397,396.4c-6.6,4.6-13.4,8.3-20.6,11.7c-7.4,3.5-14.5,3.2-22.3,2.3c-14.9-1.6-30.5-13-42.3-21.6 c-1.4-1-2.8-2.1-4.3-3.1c-0.8-0.6-1.6-1.2-2.4-1.8c-0.5-0.4-1.1-0.8-1.6-1.2c-1-0.8-2-1.5-3-2.3c-0.3-0.2-0.6-0.5-0.9-0.7 c-1.1-0.9-2.2-1.7-3.3-2.6l0,0c20.8,36.1,65.9,54.9,106.8,49.6c5.4-0.8,10.7-2.1,15.9-3.8c1.9-0.6,3.8-1.3,5.6-2.1 c-2.6-13.7-4-27.1-4.2-41.1l0,0c-6.9,5.3-14.1,10.2-20.8,14.8C398.8,395.2,397.9,395.8,397,396.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC9E65",
    d: "M600.8,579.3c-31.2,4.5-62.2,10-93,16.8c-6.9,1.5-13.9,2.9-20.7,4.8c-1.9,0.5-9.6,2-6.3,5.7 c1.6,1.8,13.4,0.6,16.5,0.4c15.3-1.1,26.8-2.8,42-4.3c19.8-2,39.6-4.2,59.4-6.9c-0.6-4.5-1.3-9-1.9-13.4 C600.1,582,600.9,580.9,600.8,579.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC9E65",
    d: "M224.4,609.9c-7.7-1.9-15.7-2.7-23.6-3.5c-32.2-3.2-61.2-2.7-91.2-2.3c-0.4,4.9,0,4.2,0.3,4.4 c3.9,0.4,9.6-0.7,9.6,0c0,3.4,0.1,8,0.2,12.1c14.5-0.1,29.1-0.1,43.6-0.5c16.8-0.5,33.5-1.3,50.2-2.9c4-0.4,8-1.1,11.9-2 C230.3,614,227.7,610.8,224.4,609.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody2A);
export default __webpack_public_path__ + "static/media/body_2a.7f9b4cfabf176369bf2a2ce9d3bff67c.svg";
export { ForwardRef as ReactComponent };